import './react-pro-sidebar.css';
import React from 'react';
import UserProfile from 'components/user/user-profile';
import { Link } from "react-router-dom";
import { Sidebar, sidebarClasses, Menu, MenuItem, menuClasses, useProSidebar, } from 'react-pro-sidebar';
import { getAuth } from "firebase/auth";
import { useSelector } from 'react-redux';

export default function SideMenu(props) {

    const { collapseSidebar, collapsed } = useProSidebar();

    const firebaseUser = getAuth().currentUser;
    const email = firebaseUser?.email;

    return (

        <div style={{ display: 'flex', height: '100%', position: 'absolute', zIndex: 9999 }}
            onMouseEnter={() => collapseSidebar(false)}
            onMouseLeave={() => collapseSidebar(true)}
        >
            <Sidebar
                width={'240px'}
                style={{ height: '100vh' }}
                defaultCollapsed={true}
                collapsedWidth='80px'
                backgroundColor='#2f4050'
                rootStyles={{
                    [`.${menuClasses.active}`]: {
                        color: '#ffffff',
                        backgroundColor: '#666633',
                        // width: '220px',
                    },
                    [`.${menuClasses.button}:hover.${menuClasses.active}`]: {
                        color: '#ffffff',
                        backgroundColor: '#666633',
                        // width: '220px',
                    },
                    [`.${menuClasses.button}:hover`]: {
                        color: '#ffffff',
                        backgroundColor: '#999966 !important',
                        // width: '220px',
                    },
                    [`.${sidebarClasses.container}`]: {
                        fontSize: '14px',
                        color: '#ababab',
                    },
                }}
            >
                <Menu iconShape="circle" closeOnClick={true} >
                    <div style={{ minHeight: '180px', marginBottom: '20px' }} >
                        {props.userRoles && props.user && email &&
                            <UserProfile user={props.user} email={email} userRoles={props.userRoles} collapsed={collapsed} />
                        }
                    </div>
                    <MenuItem
                        active={props.location.pathname.startsWith('/' + props.handle + '/dashboard')}
                        icon={<i className="fas fa-tachometer-alt"></i>}
                        component={<Link onClick={() => collapseSidebar(true)} to={'/' + props.handle + '/dashboard'} />}
                        >DASHBOARD
                    </MenuItem>

                    {/* <MenuItem
                        active={props.location.pathname.startsWith('/' + props.handle + '/assets')}
                        icon={<i className="fas fa-truck"></i>}
                        component={<Link onClick={() => collapseSidebar(true)} to={'/' + props.handle + '/assets/' + targetAsset} />}
                    >
                        ASSETS
                    </MenuItem>

                    <MenuItem
                        active={props.location.pathname.startsWith('/' + props.handle + '/stock_parts')}
                        icon={<i className="fas fa-toolbox fa-lg"></i>}
                        component={<Link onClick={() => collapseSidebar(true)} to={'/' + props.handle + '/stock_parts/' + targetAsset} />}
                    >
                        STOCK PARTS
                    </MenuItem>

                    <MenuItem
                        active={props.location.pathname.startsWith('/' + props.handle + '/vendors/vendor')}
                        icon={<i className="fas fa-store"></i>}
                        component={<Link onClick={() => collapseSidebar(true)} to={'/' + props.handle + '/vendors/vendor'} />}
                    >
                        VENDORS
                    </MenuItem>

                    <MenuItem
                        active={props.location.pathname.startsWith('/' + props.handle + '/schedule')}
                        icon={<i className="far fa-calendar-alt fa-lg"></i>}
                        component={<Link onClick={() => collapseSidebar(true)} to={'/' + props.handle + '/schedule/' + moment().format('YYYY-MM-DD')} />}
                    >
                        SCHEDULE
                    </MenuItem> */}


                    <MenuItem
                        active={props.location.pathname.startsWith(`/${props.handle}/employees`)}
                        icon={<i className="fas fa-id-badge fa-lg" aria-hidden="true"></i>}
                        component={<Link onClick={() => collapseSidebar(true)} to={'/' + props.handle + '/employees'} />}
                        >EMPLOYEES
                    </MenuItem>
                    <MenuItem
                        icon={<i className="fas fa-tools fa-lg"></i>}
                        component={<a href="https://assetmanager.mobiletrack.systems/#/rollin" target="_blank" />}>
                        MAINT <i className="fas fa-external-link-alt ml-2"></i>
                    </MenuItem>

                    <div className="mb-5"></div>
                    <MenuItem
                        rootStyles={{ position: 'absolute', left: 0, bottom: 100 }}
                        active={props.location.pathname.startsWith('/' + props.handle + '/settings')}
                        icon={<i className="fas fa-cog"></i>}
                        component={<Link onClick={() => collapseSidebar(true)} to={'/' + props.handle + '/settings/company'} />}
                        >SETTINGS
                    </MenuItem>
                    <MenuItem
                        rootStyles={{ position: 'absolute', left: 0, bottom: 50 }}
                        active={props.location.pathname.startsWith('/' + props.handle + '/archive')}
                        icon={<i className="fas fa-archive"></i>}
                        component={<Link onClick={() => collapseSidebar(true)} to={'/' + props.handle + '/archive'} />}
                        >ARCHIVE
                    </MenuItem>
                </Menu>
                <main style={{ position: 'absolute', left: 10, bottom: 5 }}>
                    <center>
                        {window.build}
                    </center>
                </main>
            </Sidebar>
        </div>
    );
}
